import { axiosRequest } from "../../helper";

/**
 * Client dashboard Details Api
 * @returns
 */
export const ClientdashboardDetailsApi = async () => {
  return await axiosRequest("GET", `/admin/dashboard-client`);
};
